import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "cross--fill-current-color",
  "use": "cross--fill-current-color-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1024 1024\" id=\"cross--fill-current-color\">\n<title></title>\n<g id=\"cross--fill-current-color_icomoon-ignore\">\n</g>\n<path d=\"M594.534 512l412.365 412.467c9.303 10.299 14.995 24.014 14.995 39.059 0 32.236-26.132 58.368-58.368 58.368-15.045 0-28.76-5.692-39.11-15.040l0.051 0.045-412.467-412.365-412.467 412.365c-10.299 9.303-24.014 14.995-39.059 14.995-32.236 0-58.368-26.132-58.368-58.368 0-15.045 5.692-28.76 15.040-39.11l-0.045 0.051 412.365-412.467-412.365-412.467c-9.303-10.299-14.995-24.014-14.995-39.059 0-32.236 26.132-58.368 58.368-58.368 15.045 0 28.76 5.692 39.11 15.040l-0.051-0.045 412.467 412.365 412.467-412.365c10.299-9.303 24.014-14.995 39.059-14.995 32.236 0 58.368 26.132 58.368 58.368 0 15.045-5.692 28.76-15.040 39.11l0.045-0.051-412.365 412.467z\" fill=\"currentColor\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/cross.svg?fill=currentColor
// module id = ujHT
// module chunks = 1